import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import posthog from 'posthog-js';

@Injectable({ providedIn: 'root'})
export class PosthogService {

	public isEnabled(key: string) {
		if (environment.posthog) {
			return posthog.isFeatureEnabled(key);
		}
		return false;
	}
}